import { SortDescriptor } from "react-aria-components";

import { VcsAgentPoolView } from "../types";
import { VCS_AGENT_POOLS_COLUMN_ID } from "./constants";

export const sortVcsAgentPools = (
  vcsAgentPools: VcsAgentPoolView[],
  sortDescriptor: SortDescriptor
) => {
  if (!sortDescriptor.column) {
    return vcsAgentPools;
  }

  const isAscending = sortDescriptor.direction === "ascending";

  return [...vcsAgentPools].sort((a, b) => {
    let valueA: string | undefined;
    let valueB: string | undefined;

    switch (sortDescriptor.column as VCS_AGENT_POOLS_COLUMN_ID) {
      case VCS_AGENT_POOLS_COLUMN_ID.NAME:
        valueA = a.name;
        valueB = b.name;
        break;
      case VCS_AGENT_POOLS_COLUMN_ID.AGENT_CONNECTIONS:
        valueA = a.agentConnections.length.toString();
        valueB = b.agentConnections.length.toString();
        break;
      case VCS_AGENT_POOLS_COLUMN_ID.DESCRIPTION:
      case VCS_AGENT_POOLS_COLUMN_ID.DROPDOWN:
        break;
    }

    valueA = valueA || "";
    valueB = valueB || "";

    return isAscending
      ? valueA.localeCompare(valueB, undefined, { numeric: true })
      : valueB.localeCompare(valueA, undefined, { numeric: true });
  });
};
